var React = require('react');

function ScrollDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.5,0C7.39,0,0,7.39,0,16.5s7.39,16.5,16.5,16.5,16.5-7.39,16.5-16.5S25.61,0,16.5,0Zm8.21,14.71l-7,7-.71,.71-.71-.71-7-7c-.39-.39-.39-1.02,0-1.41,.39-.39,1.02-.39,1.41,0l6.29,6.29,6.29-6.29c.39-.39,1.02-.39,1.41,0,.39,.39,.39,1.02,0,1.41Z","style":{"fill":"#fff"}}));
}

ScrollDown.defaultProps = {"width":"31","id":"scrollDownIcon","height":"31","viewBox":"0 0 33 33"};

module.exports = ScrollDown;

ScrollDown.default = ScrollDown;
